import PlansEditor from './PlansEditor';

export default PlansEditor;
